export default "__VITE_PUBLIC_ASSET__97a32721__"